/* Einheitliche Uhrenkarte: Uebergang Karte -> Produktseite (Robin 29.09., Mockup Runde 3 „Uhr fliegt mit“).
   Beim Klick auf eine Karte merkt sich das Skript das Ziel (sessionStorage mwbVT, das Head-Skript in
   layout/theme.liquid liest es auf der Produktseite). In Browsern mit verschachtelten View-Transition-
   Gruppen (Chrome/Edge) steht die Freigabe @view-transition hier schon ab dem Laden: Shopify laedt die
   Produktseite beim Ueberfahren vorab (Prefetch), dann prueft Chrome die Freigabe, bevor der Klick-
   Handler laeuft (live 29.09.: nach Hover nie ein Uebergang). Die Zielseite gibt nur nach einem
   Kartenklick frei, jeder andere Seitenwechsel hat also keine View Transition; pageswap ueberspringt
   ihn zusaetzlich. Beim Kartenklick werden Fenster und Foto benannt: Das Fenster wird zur gruenen
   Buehne, die Uhr fliegt darin an ihren Platz. Safari/Firefox bekommen keine Freigabe, dort startet
   die Buehne beige und blendet ins Gruen.
   Kein Skript beim Scrollen oder Laden; das Einpassen der Fotos steht in layout/theme.liquid (mwbFit). */
(function () {
  var media = null, img = null;
  var nested = !!(window.CSS && CSS.supports('view-transition-group: nearest')) && 'onpageswap' in window;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (nested && !calm) {
    var optin = document.createElement('style');
    optin.textContent = '@view-transition { navigation: auto; }';
    document.head.appendChild(optin);
  }
  function reset() {
    if (media) { media.style.viewTransitionName = ''; media.classList.remove('mwb-wc__media--vt'); }
    if (img) { img.style.viewTransitionName = ''; img.style.viewTransitionGroup = ''; }
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.mwb-wc__link');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var card = link.closest('.mwb-wc');
    media = card && card.querySelector('.mwb-wc__media');
    img = media && media.querySelector('.mwb-wc__img--a');
    try { sessionStorage.setItem('mwbVT', new URL(link.href, location.href).pathname); } catch (err) {}
  }, true);
  window.addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    var target = '';
    try { target = sessionStorage.getItem('mwbVT') || ''; } catch (err) {}
    var dest = e.activation && e.activation.entry ? new URL(e.activation.entry.url).pathname : '';
    /* Uebersprungene Uebergaenge lehnen .ready ab; ohne catch meldet Chrome das als Fehler in der Konsole */
    e.viewTransition.ready.catch(function () {});
    if (!media || !img || !target || dest !== target) { e.viewTransition.skipTransition(); return; }
    /* Beim Klick liegt die Maus auf der Karte, dort ist die Schliesse eingeblendet: Fuer den Flug
       sofort das Frontbild zeigen, sonst fliegt ein unsichtbares Foto. */
    media.classList.add('mwb-wc__media--vt');
    media.style.viewTransitionName = 'mwb-watch';
    img.style.viewTransitionName = 'mwb-watch-img';
    img.style.viewTransitionGroup = 'nearest';
  });
  /* Zurueck per bfcache: Namen entfernen, sonst fliegt beim naechsten Seitenwechsel die alte Karte */
  window.addEventListener('pageshow', reset);
})();
